function gaSendUserEvent(eventName, eventValue = null) {
  if (window.ga) {
    window.ga('send', 'event', 'user', eventName, eventValue);
  }
}

const gaEventName = {
  clickChangeCategory: 'click change category',
  clickShowAttachments: 'click show attachments',
  clickRequestReceipt: 'click request receipt',
  clickRequestExpenseType: 'click request expense_type',
  clickDownloadTransactionsCSV: 'click download transactions CSV',
  clickDownloadFilesZip: 'click download files',
  selectAnnaAccount: 'select anna account',
  selectOpenbankingAccount: 'select openbanking account',
  selectExpensesOtherBusinessAccount: 'select expenses other business account',
  selectExpensesBusinessCash: 'select expenses business cash',
  selectExpensesPaidByDirector: 'select expenses paid by director',
  selectManualAccountCash: 'select manual account cash',
  selectManualAccountBank: 'select manual account bank',
  selectManualAccountOther: 'select manual account other',
  selectDatetimeRange: 'select datetime range',
};

export { gaSendUserEvent, gaEventName };
